import { formatDistance } from 'date-fns';
import twoDigits from './twoDigits';

export const withTimezone = ({ datetime, timezone }: { datetime: string; timezone?: string | undefined | null }): string => (
  new Date(datetime).toLocaleDateString(
    'default',
    {
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      month: 'short',
      timeZone: timezone || undefined,
      timeZoneName: 'short',
    },
  )
);

export const dateString = (dateObject: Date): string => {
  const year = dateObject.getFullYear().toFixed(0);
  const month = twoDigits(dateObject.getMonth() + 1);
  const day = twoDigits(dateObject.getDate());
  return `${year}-${month}-${day}`;
};

export const timeSince = ({ date }: { date: Date | string }): string => {
  const dateObject = typeof date === 'string' ? new Date(date) : date;
  return formatDistance(dateObject, new Date());
};